import React, { useState } from 'react';
import QrReader from 'react-qr-reader';

export const BadgeUsagePage: React.FC = () => {
  const [result, setResult] = useState<string>('No Result');

  const handleScan = (data: string | null) => {
    setResult(data ?? 'No Result');
  };

  const handleError = (error: Error) => console.log(error);

  return (
    <div>
      <QrReader
        delay={300}
        onError={handleError}
        onScan={handleScan}
        style={{ width: '50%' }}
      />
      <p>{result}</p>
    </div>
  );
};
